const TEN_DIGIT_US_PHONE_NUMBER = /^(?:\+1)?(\d{3})(\d{3})(\d{4})$/;

export const formatPhoneNumber = (
  phoneNumber?: string | null,
): string | null | undefined => {
  if (!phoneNumber) {
    return phoneNumber;
  }

  const match = phoneNumber.match(TEN_DIGIT_US_PHONE_NUMBER);
  if (!match) {
    return phoneNumber;
  }

  const [, areaCode, exchange, subscriber] = match;
  return `(${areaCode}) ${exchange}-${subscriber}`;
};

export default formatPhoneNumber;
